/** Auto-detect touch-first devices so the mobile control scheme is selected
 *  automatically. Treated as a hint; the control scheme is otherwise swappable. */
export function isTouchDevice(): boolean {
  if (typeof window === 'undefined') return false;
  const coarse = window.matchMedia?.('(pointer: coarse)').matches ?? false;
  const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  return coarse || hasTouch;
}
